import Service from './Service';
import UserAccount from './UserAccount';

class LogicBaseNotificationPopup extends Service {
  __open = false;

  open() {
    this.__open = true;
    this.emitStateUpdate();
  }

  close() {
    this.__open = false;
    this.emitStateUpdate();
  }

  get isOpen() {
    return this.__open;
  }
}

const singleton = new LogicBaseNotificationPopup();
UserAccount.onStateUpdate(() => {
  if (!UserAccount.isLoggedIn) singleton.close();
});

export default singleton;
